import { render, staticRenderFns } from "./OrderBrief.vue?vue&type=template&id=4649f81c&"
import script from "./OrderBrief.vue?vue&type=script&lang=js&"
export * from "./OrderBrief.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports